import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { themeColors } from '../theme';
import { CheckCircleTwoTone, GlobalOutlined } from '@ant-design/icons';
import { Drawer } from 'antd';
import useAnalyticsEventTracker from '../hooks/useAnalyticsEventTracker';

const Language = () => {
    const [languageModal, setLanguageModal] = useState(false);
    const logGAEvent = useAnalyticsEventTracker('language');

    const { langList, changeLanguage, lang = 'en' } = useLanguage();

    // bottom sheeet
    const changeLanguageHandler = (lang) => {
        logGAEvent('language_changed', lang);
        changeLanguage(lang);
        setLanguageModal(false);
    };

    const globeIconClickHandler = () => {
        setLanguageModal(true);
        logGAEvent('lang_globe_icon_clicked', 'language_modal_open');
    };
    const languageModalCloseHandler = () => {
        setLanguageModal(false);
        logGAEvent('language_modal_closeed', 'language_modal_close');
    };

    return (
        <>
            <div
                className='flex justify-center items-center py-1 px-1 rounded-full flex-row w-9 h-9'
                onClick={globeIconClickHandler}
            >
                <div className='font-medium text-black text-sm'>
                    <GlobalOutlined
                        style={{ fontSize: '30px', color: 'white' }}
                    />
                </div>
            </div>
            <Drawer
                title='Change Language'
                placement={'bottom'}
                closable={false}
                onClose={languageModalCloseHandler}
                open={languageModal}
            >
                {langList.map((item, index) => (
                    <div
                        key={item.id}
                        onClick={() => changeLanguageHandler(item.lang_code)}
                        className={
                            'flex flex-row justify-between items-center p-2 px-4 rounded-xl mb-3 h-12 bg-slate-200' +
                            (index === langList.length ? ' mb-6 ' : ' ')
                        }
                        style={{
                            backgroundColor:
                                lang == item.lang_code
                                    ? themeColors.bgColor(0.5)
                                    : '',
                        }}
                    >
                        <div className=' text-black text-sm'>
                            {item.lang_name}
                        </div>
                        {item.lang_code === lang && (
                            <CheckCircleTwoTone twoToneColor='green' />
                        )}
                    </div>
                ))}
            </Drawer>
        </>
    );
};

export default Language;
